<style scoped>
    .introduction .staff-card{
        margin: 4px 2px;
        width: 210px;
    }
    .title{
        /*background-color: #5cadff;*/
        background-color: #515a6e;
        font-size: 24px;
        color: white;
    }
    .wiki{
        font-size: 18px;
    }
</style>
<template>
  <div class="introduction">
    <table class="mis-table">
      <tr>
        <td
          class="title"
          width="170"
        >
          <div class="title">
            成都C区
          </div>
        </td>
        <td>
          <StaffCard
            class="staff-card"
            :is_wx_work="true"
            :duty_height="72"
            :staff="staffs.liqixiang"
          />
          <StaffCard
            class="staff-card"
            :is_wx_work="true"
            :duty_height="72"
            :staff="staffs.yangqingqing"
          />
          <StaffCard
            class="staff-card"
            :is_wx_work="true"
            :duty_height="72"
            :staff="staffs.tanhengzhi"
          />
          <StaffCard
            class="staff-card"
            :is_wx_work="true"
            :duty_height="72"
            :staff="staffs.xionghui"
          />
        </td>
        <td width="" />
      </tr>
      <tr>
        <td class="title">
          <div class="title">
            成都E区
          </div>
        </td>
        <td>
          <StaffCard
            class="staff-card"
            :is_wx_work="true"
            :duty_height="54"
            :staff="staffs.sunjun"
          />
          <StaffCard
            class="staff-card"
            :is_wx_work="true"
            :duty_height="54"
            :staff="staffs.shiyouxin"
          />
        </td>
        <td />
      </tr>
      <tr>
        <td class="title">
          <div class="title">
            北京
          </div>
        </td>
        <td>
          <StaffCard
            class="staff-card"
            :is_wx_work="true"
            :duty_height="54"
            :staff="staffs.hezhiqian"
          />
        </td>
        <td />
      </tr>
    </table>
  </div>
</template>
<script route="/exec/introduction">
  import StaffCard from '../fin/components/staff_card';
  export default {
    /* router_info_start */
    router_info: {
      path: '/exec/introduction',
      noChkout: true
    },
    /* router_info_end */
    components: { StaffCard },
    data() {
      return {
        staffs: {
          liqixiang: {
            name: '李祈祥',
            nickname: '李斯特',
            duty: '<p>办公空间整体统筹</p><p>部门信息资料库维护</p>',
            email: 'liqixiang@baicizhan.com',
            avatar: 'exec_photo/liqixiang.jpg',
            wechat_image: 'exec_photo/wechat/liqixiang_wx.jpg',
            mobile: '18200389161'
          },
          hezhiqian: {
            name: '何知谦',
            nickname: '谦谦',
            duty: '<p>差旅管家</p><p>北京办公空间</p>',
            email: 'hezhiqian@baicizhan.com',
            avatar: 'exec_photo/hezhiqian.jpg',
            wechat_image: 'exec_photo/wechat/hezhiqian_wx.png',
            mobile: '18030645519'
          },
          sunjun: {
            name: '孙珺',
            nickname: '珺珺',
            duty: '<p>固定资产</p><p>员工用餐</p><p>E区办公空间</p>',
            email: 'sunjun@baicizhan.com',
            avatar: 'exec_photo/sunjun.jpg',
            wechat_image: 'exec_photo/wechat/sunjun_wx.png',
            mobile: '15002807804'
          },
          shiyouxin: {
            name: '史有鑫',
            nickname: '小鑫',
            duty: '<p>E区日常网络管理</p><p>电子设备</p><p>视频会议及机房运维</p>',
            email: '429766884@qq.com',
            avatar: 'exec_photo/shiyouxin.jpg',
            wechat_image: 'exec_photo/wechat/shiyouxin_wx.png',
            mobile: '13880784062'
          },
          tanhengzhi: {
            name: '谈恒志',
            nickname: '恒志',
            duty: '<p>C区日常网络管理</p><p>电子设备</p><p>视频会议及机房运维</p>',
            email: '897340359@qq.com',
            avatar: 'exec_photo/tanhengzhi.jpg',
            wechat_image: 'exec_photo/wechat/tanhengzhi_wx.png',
            mobile: '15828073160'
          },
          xionghui: {
            name: '熊慧',
            nickname: 'Ashley',
            duty: '<p>行政部所有问题</p>',
            email: 'xionghui@baicizhan.com',
            avatar: 'exec_photo/xionghui.jpg',
            wechat_image: 'exec_photo/wechat/xionghui_wx.png',
            mobile: '17783115827'
          },
          yangqingqing: {
            name: '杨青青',
            nickname: '青青',
            duty: '<p>团建会务支持</p><p>集团采购</p><p>C区办公空间</p>',
            email: 'yangqingqing@baicizhan.com',
            avatar: 'exec_photo/yangqingqing.jpg',
            wechat_image: 'exec_photo/wechat/yangqingqing_wx.png',
            mobile: '18108257785'
          },
        }
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>
